import { type MessageKey } from '@ecom/i18n';
import { resolveErrorMessageKey } from '@ecom/i18n/errors';

import { ApiError } from './api-client';

/**
 * The message an image upload (product photo, logo, banner) shows when it fails.
 *
 * A 4xx refusal is about THIS file and the API words it precisely (« Image too small: 100×100 px. The minimum
 * for a logo is 128×128 px. »), so it is relayed as written. A 5xx is never about the file — the storage is
 * down, the server failed — and its raw text (« An unexpected error occurred. ») is technical English: it goes
 * through the translated catalogue instead (`STORAGE_UNAVAILABLE` → « Le service d'images est momentanément
 * indisponible… »). Anything that is not an API response at all keeps the generic « Échec de l'envoi. ».
 */
export function uploadErrorMessage(error: unknown, t: (key: MessageKey) => string): string {
  if (!(error instanceof ApiError)) return t('merchant.products.images.uploadFailed');
  if (error.status >= 500) return t(resolveErrorMessageKey(error));
  return error.message;
}
